var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSyncBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "link-broken-01",
    clipPath: "url(#clip0_5202_86908)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6.00065 2.66732V1.33398M10.0007 13.334V14.6673M2.66732 6.00065H1.33398M13.334 10.0007H14.6673M3.27679 3.27679L2.33398 2.33398M12.7245 12.7245L13.6673 13.6673M8.00065 11.7719L6.58644 13.1861C5.54504 14.2275 3.8566 14.2275 2.8152 13.1861C1.7738 12.1447 1.7738 10.4563 2.8152 9.41487L4.22942 8.00065M11.7719 8.00065L13.1861 6.58644C14.2275 5.54504 14.2275 3.8566 13.1861 2.8152C12.1447 1.7738 10.4563 1.7738 9.41486 2.8152L8.00065 4.22942",
    stroke: "#F03840",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5202_86908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncBroken);
export default __webpack_public_path__ + "static/media/sync-broken.131f3ece393a3055fc7ec2783d35508d.svg";
export { ForwardRef as ReactComponent };